import axios from "axios";

const token = localStorage.getItem("token");

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
API.interceptors.request.use(
  (config) => {
    // Check internet
    if (typeof navigator !== "undefined" && !navigator.onLine) {
      return Promise.reject({
        message: "No internet connection",
        isOffline: true,
      });
    }

    // Get latest token every request
    const token = localStorage.getItem("token");

    if (token && token.trim() !== "") {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Timeout
    if (error.code === "ECONNABORTED") {
      return Promise.reject({
        message: "Request timeout. Please try again.",
        status: 408,
      });
    }

    const status = error?.response?.status;

    // Unauthorized
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }

      return Promise.reject(error);
    }

    // Retry only GET requests on server/network failure
    const config = error.config;

    if (
      config &&
      config.method === "get" &&
      (!error.response || status >= 500)
    ) {
      config.__retryCount = config.__retryCount || 0;

      if (config.__retryCount < 2) {
        config.__retryCount++;
        return API(config);
      }
    }

    return Promise.reject({
      message:
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong",
      status,
      data: error?.response?.data,
    });
  }
);

export default API;